module.exports = {"component":"app-launcher","status":"prototype","display-name":"App Launcher","SLDS-component-path":"/components/app-launcher/#flavor-default","dependencies":[{"component":"section"},{"component":"tile"}],"url-slug":"app-launcher"}


//////////////////
// WEBPACK FOOTER
// ./components/app-launcher/docs.json
// module id = 87
// module chunks = 0